<template>
    <div>
        <!--<div style="position:fixed; left:0px; top:0px; width:100%; height:100%; background: rgba(0, 0, 0, 0.2);"></div>-->
        <div style="flex:1;display:flex; flex-direction: column;">

            <div style="flex:1;"></div>
            <div class="popup_wrap" style="">
                <div style="display: flex; flex-direction: column; height: 100%;">
                    <div>
                        <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
                    </div>
                    <div style="flex: 1; position: relative;">
                        <div style="display: flex; margin-top: 53px; padding: 0 32px; align-items: center; justify-content: space-between;">
                            <div style="display: flex; flex-direction: column; align-items: center;">
                                <ProfileImage :image-path="left_member.image_path" style="width: 100px;"></ProfileImage>
                                <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                    <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ left_member.nic_name }}</div>
                                    <div v-if="left_member.is_coach == '0'" style="font-size: 11px; font-weight: 900; color: var(--color-main);">{{ left_member.position }}</div>
                                    <div v-else>
                                        <img v-if="left_member.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; gap: 4px;">
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            </div>
                            <div style="display: flex; flex-direction: column; align-items: center;">
                                <ProfileImage :image-path="right_member.image_path" style="width: 100px;"></ProfileImage>
                                <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                    <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ right_member.nic_name }}</div>
                                    <div v-if="right_member.is_coach == '0'" style="font-size: 11px; font-weight: 900; color: var(--color-main);">{{ right_member.position }}</div>
                                    <div v-else>
                                        <img v-if="right_member.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 40px; text-align: center;">
                            <div style="font-weight: 700; font-size: 20px; line-height: 32px;">채팅을 오픈했습니다👏<br>입단 테스트 일정을 잡으세요!</div>
                        </div>
                        <div @click="showPesonalChat" style="border-radius: 40px; margin: 0 auto; margin-top: 40px; width: 237px; height: 56px; line-height: 56px; background-color: #210f03; text-align: center; font-size: 14px; color: var(--color-main); font-weight: 700;">대화 시작하기</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import ProfileImage from "../../common/ProfileImage";
    import ResponseCode from "../../../ResponseCode";
    import {JOIN_CHAT_TYPE, MEMBER_TYPE, TEAM_TYPE} from "../../../Constants";
    export default {
        name: "ChatOpenPopup",
        components: {ProfileImage},
        props : {
            left_member : {
                type : Object,
                default : () => {}
            },
            right_member : {
                type : Object,
                default : () => {}
            },
            chat_idx : {
                type : [Number, String],
                default : -1
            }
        },
        data() {
            return {
                TEAM_TYPE: TEAM_TYPE
            }
        },
        methods : {
            async confirmPopup(){
                const parameters = {};
                parameters.chat_idx = this.chat_idx;
                const res = await this.$Axios.post('/api/chat/coach_chat/confirmed', parameters);
                if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            async showPesonalChat(){
                await this.confirmPopup();
                this.$GlobalStore.closeLastModal();
                await this.$Axios.showPersonalChat(this.right_member.idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_WITH_COACH);
            },
            async closeBookmarkPopup(){
                await this.confirmPopup();
                this.$GlobalStore.closeLastModal();
            }
        },
        created() {
            this.showPesonalChat = this.$Once(this.showPesonalChat);
            this.confirmPopup = this.$Once(this.confirmPopup);
        }

    }
</script>

<style scoped>
    .popup_wrap{height:460px; width:100%; left:0px; background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);padding: 20px; padding-top: 16px; border-top-left-radius: 25px;
    border-top-right-radius: 25px;}
</style>